// extracted by mini-css-extract-plugin
export default {"bar":"BarRenown_bar__UMDKp bar_bar__ELotW","progress":"BarRenown_progress__KOyKK bar_barProgress__QOs4-"};